import type { CommandDeckContinueResolution } from './resolveCommandDeckContinue'
import type { CommandDeckPreviewBundle, CommandDeckSurfaceMode } from '../contracts/types'
import type { WorkContextFieldSource } from './commandDeckWorkContext'

export type DeckPulseLine = {
  text: string
  source: WorkContextFieldSource
}

export type CommandDeckDeckPulseModel = {
  title: string
  statusLabel: string
  lines: DeckPulseLine[]
}

export function deriveCommandDeckDeckPulse(input: {
  bundle: CommandDeckPreviewBundle
  mode: CommandDeckSurfaceMode
  continueResolution: CommandDeckContinueResolution
}): CommandDeckDeckPulseModel {
  const { bundle, mode, continueResolution } = input
  const projectName = bundle.progress.projectName

  const lines: DeckPulseLine[] =
    mode === 'preview'
      ? [
          { text: 'Preview context — readback only', source: 'preview' },
          { text: `Context derived from ${projectName} bundle`, source: 'bundle' },
        ]
      : [
          { text: 'Deck state reflects current session', source: 'bundle' },
          { text: `Context derived from ${projectName} bundle`, source: 'bundle' },
        ]

  if (continueResolution.label) {
    lines.push({
      text: `Next safe action aligned with ${continueResolution.label}`,
      source: 'continue',
    })
  }

  lines.push(
    { text: 'Library connection pending', source: 'placeholder' },
    { text: 'Pinned items planned', source: 'placeholder' },
  )

  return {
    title: 'Deck pulse',
    statusLabel: mode === 'preview' ? 'Preview readback' : 'Current known state',
    lines,
  }
}
